import {observer} from "mobx-react-lite";
import { SearchDetailView } from "../views/searchDetailView";
import { NavBar } from "./navBarPresenter";


const Detail = observer(
    function DetailRender(props){
        
        return (<div>
        <NavBar model={props.model}/>
        <SearchDetailView detailResult={props.model.detailInfo}
        page={props.model.page}/>
        </div>)}
    
);
    
export { Detail };